import { useIsMobile } from '../../../../../utils/getIsMobile';
import { IconBookmarkAction } from '../../../../icon/IconBookmarkAction';
import { IconBookmarkActionFilled } from '../../../../icon/IconBookmarkActionFilled';
import { IconCalendarWithClock } from '../../../../icon/IconCalendarWithClock';
import { IconLikeAction } from '../../../../icon/IconLikeAction';
import { IconLikeFilled } from '../../../../icon/IconLikeFilled';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Typography } from '../../../../typography/Typography';
import { isPostStatusValidForSave } from '../../../PostDetailsCard/parts/utils/isPostStatusValidForSave';
import { ViewsBadge } from '../ViewsBadge/ViewsBadge';
import { useCardActionsFlags } from './hooks/useCardActionsFlags';
import { useCardActionsHandlers } from './hooks/useCardActionsHandlers';
import {
    ActionsWrapper,
    Button,
    CardActionsWrapper,
    TextWrapper,
    LeftBadgesWrapper,
    BookingButton,
} from './styles';
import { CardActionsProps } from './types';

export const CardActions: React.FC<CardActionsProps> = ({
    post,
    index,
    onReaction,
    onBookmark,
    ...other
}) => {
    const { text, reactionState, saved, publicStats } = post;
    const isMobile = useIsMobile();
    const { withCheckout, hasBookingBadge, hasViewsBadge } = useCardActionsFlags(post);
    const { onLikeClick, onBookmarkClick } = useCardActionsHandlers({
        index,
        onReaction,
        onBookmark,
    });

    return (
        <CardActionsWrapper {...other} isMobile={isMobile}>
            {hasViewsBadge || hasBookingBadge ? (
                <LeftBadgesWrapper>
                    {hasBookingBadge ? (
                        <BookingButton>
                            <IconCalendarWithClock fontSize={20} color="var(--always-white)" />
                        </BookingButton>
                    ) : null}
                    {hasViewsBadge ? (
                        <ViewsBadge
                            views={publicStats?.shows || 0}
                            background="var(--content-overlay-medium)"
                        />
                    ) : null}
                </LeftBadgesWrapper>
            ) : null}
            {text ? (
                <TextWrapper mb={withCheckout ? 5.5 : undefined}>
                    <Typography
                        variant="caption"
                        color="var(--always-white)"
                        width="100%"
                        lines={3}
                    >
                        {text}
                    </Typography>
                </TextWrapper>
            ) : null}
            <ActionsWrapper>
                <Button
                    onClick={onLikeClick}
                    dataTestId={reactionState === 'like' ? DataTestId.LIKE : DataTestId.DISLIKE}
                >
                    {reactionState === 'like' ? (
                        <IconLikeFilled fontSize={16} color="var(--always-white)" />
                    ) : (
                        <IconLikeAction fontSize={16} color="var(--always-white)" />
                    )}
                </Button>

                {isPostStatusValidForSave(post.status) && !post.ownersData?.isOwner ? (
                    <Button onClick={onBookmarkClick} dataTestId={DataTestId.BOOKMARK}>
                        {saved ? (
                            <IconBookmarkActionFilled fontSize={16} color="var(--always-white)" />
                        ) : (
                            <IconBookmarkAction fontSize={16} color="var(--always-white)" />
                        )}
                    </Button>
                ) : null}
            </ActionsWrapper>
        </CardActionsWrapper>
    );
};
